import api from '@/api/';
import tips from '@/components/tips/main';
import qs from "qs"
import router from '@/router';
import instantiationPromise from "@/library/promiseTool";
let authorizeAli = {
  doAuth() {
    let redirectOauthUrl = window.location.protocol + "//h5.mgzf.com" + `${window.location.pathname}${window.location.search}`;  // 转换过后的redirectUrl
    // 获取对应环境appId, 并去授权页面
    api.authorize.loadAppIdConfig()
      .then(({ data }) => {
        if (data.code == 10000) {
          location.href = `https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=${data.content}&scope=auth_userinfo&redirect_uri=${window.encodeURIComponent(redirectOauthUrl)}&state=${window.encodeURIComponent(window.location.origin)}`
        }
      }).catch(err => {
        tips('获取appid失败!')
      })
  },
  doCode() {
    let tempQuery = qs.parse(window.location.href.split('?')[1]);
    let auth_code = tempQuery.auth_code;
    delete tempQuery.auth_code;
    var querystring = qs.stringify(tempQuery);
    if (querystring) {
      window.history.replaceState({}, "", `${location.origin}${location.pathname}?` + querystring);
    } else {
      window.history.replaceState({}, "", `${location.origin}${location.pathname}`);
    }
    let {resolve:_resolveTemp ,reject:_rejectTemp, promise:promiseTemp} = instantiationPromise ();
    api.authorize.authAliPayCallBackPage({
      authCode: auth_code
    })
      .then(({ data: { code, content, message } }) => {
        if (code == 10000) {
          let alipayUserId = undefined
          if(content.weChatUserInfo && content.weChatUserInfo.userId) {
            alipayUserId = content.weChatUserInfo.userId
          }
          var auth = {
            userId: content.renterId,
            mobile: content.mobile,
            token: content.token,
            alipayUserId: alipayUserId
          }
          _resolveTemp(auth)
        } else if (code == 20003) {
          let userQuery = "";
          if(content.weChatUserInfo && content.weChatUserInfo.userId) {
            userQuery = `&alipayUserId=${content.weChatUserInfo.userId}`
          }
          router.replace(`/login?redirectUri=${window.encodeURIComponent(location.href)}&openId=${content.openId}${userQuery}`);
        } else {
          _rejectTemp(message)
          tips(message)
        }
      })
      .catch(err => {
        _rejectTemp('授权失败!')
        tips('授权失败')
      })
    return promiseTemp

  }
}
export default authorizeAli;



// WEBPACK FOOTER //
// ./src/store/modules/authorizeHelper/authorizeAli.js